import { computed, unref } from 'vue';

/**
 * useStepper — Lógica presentacional del indicador de pasos Stepper para admin.
 *
 * @param {import('vue').Ref<string[]>|string[]} steps       — Etiquetas de cada paso.
 * @param {import('vue').Ref<number>|number}     currentStep — Paso activo 1-indexed.
 *
 * @returns {{
 *   progressFraction: import('vue').ComputedRef<number>,
 *   isCompleted:      (stepIndex: number) => boolean,
 *   isActive:         (stepIndex: number) => boolean,
 *   isActiveOrDone:   (stepIndex: number) => boolean,
 * }}
 */
export function useStepper(steps, currentStep) {
    const progressFraction = computed(() => {
        const total = unref(steps).length;
        const current = unref(currentStep);

        if (total <= 1) return 0;
        if (current >= total) return 1;

        return (current - 1) / (total - 1);
    });

    const isCompleted = stepIndex => stepIndex + 1 < unref(currentStep);

    const isActive = stepIndex => stepIndex + 1 === unref(currentStep);

    const isActiveOrDone = stepIndex => stepIndex + 1 <= unref(currentStep);

    return { progressFraction, isCompleted, isActive, isActiveOrDone };
}
